import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { affiliationTypes, createAffiliationTypes } from "./affiliationTypes";
import affiliationService from "./affiliationService";
import { SuccesType } from "../review/reviewTypes";

interface affiliationState {
    affiliation: affiliationTypes | null;
    affiliations: affiliationTypes[] | null;
    loading: boolean;
    error: string | null;
}

const initialState: affiliationState = {
    affiliation: null,
    affiliations: null,
    loading: false,
    error: null,
};

// --- THUNKS ---

export const createAffiliation = createAsyncThunk<SuccesType, createAffiliationTypes,{ rejectValue: string }>(
    "affiliations/createAffiliation",  
    async (data, { rejectWithValue }) => {
        try {
            const response = await affiliationService.createAffiliations(data);
            return response;
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

export const editAffiliation = createAsyncThunk<SuccesType, createAffiliationTypes,{ rejectValue: string }>(
    "affiliations/editAffiliations",  
    async (data, { rejectWithValue }) => {
        try {
            const response = await affiliationService.editAfilliation(data);
            return response;
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

// --- SLICE ---

const affiliationSlice = createSlice({
    name: "affiliation",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        
        // 1. createAffiliation
        builder.addCase(createAffiliation.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(createAffiliation.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(createAffiliation.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Error al crear afiliación";
        });

        // 2. editAffiliation
        builder.addCase(editAffiliation.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(editAffiliation.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(editAffiliation.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Error al editar afiliación";
        });

    },
});

export default affiliationSlice.reducer;